'use strict';exports.__esModule = true;exports.setWindowDimentions = exports.initializeWindowDimensions = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _checkers = require('../../utils/checkers');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var infoName = function infoName(name) {return '/' + name;};
var SET_WINDOW_DIMENSION = infoName('SET_WINDOW_DIMENSION');
var INITIALIZE = infoName('INITIALIZE');
var setWindowDimentions = (0, _reduxAct.createAction)(SET_WINDOW_DIMENSION);
var initializeWindowDimensions = (0, _reduxAct.createAction)(INITIALIZE);

var initialState = {
  width: 0,
  height: 0,
  isMobile: null };


var handleResize = function handleResize(state, params) {return Object.assign({},
  state,
  params, {
    isMobile: (0, _checkers.isMobileDisplaySize)(params.width) });};


var initializeDimensions = function initializeDimensions(state) {return Object.assign({},
  state, {
    isMobile: (0, _checkers.isMobileDisplaySize)((0, _get2.default)(global, 'global.document.body.clientWidth')) });};


var windowDimentions = (0, _reduxAct.createReducer)(function (on) {
  on(setWindowDimentions, handleResize);
  on(initializeWindowDimensions, initializeDimensions);
}, initialState);exports.


initializeWindowDimensions = initializeWindowDimensions;exports.
setWindowDimentions = setWindowDimentions;exports.default =


windowDimentions;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/windowDimentions.js
// module id = 1296
// module chunks = 0